import React, { useEffect, useRef, useState } from "react";
import { Container, Row } from "react-grid-system";
import { useFormState } from "react-final-form";
import DwellingType from "./DwellingType";
import DwellingSize from "./DwellingSize";
import MoveDetails from "./MoveDetails";
import Fade from "../../animate/Fade";

const YourMove = () => {
  const { values } = useFormState();
  const { live_in, move_size } = values;
  const [didScrollToDwellingSize, setDidScrollToDwellingSize] = useState(false);
  const [didScrollToMoveDetails, setDidScrollToMoveDetails] = useState(false);

  const dwellingSizeRef = useRef(null);
  const moveDetailRef = useRef(null);

  useEffect(() => {
    if (live_in && !didScrollToDwellingSize) {
      setDidScrollToDwellingSize(true);
      dwellingSizeRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [live_in]);

  useEffect(() => {
    if (move_size && !didScrollToMoveDetails) {
      setDidScrollToMoveDetails(true);

      moveDetailRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [move_size]);

  return (
    <Container className="section">
      <Row>
        <DwellingType />
        <div ref={dwellingSizeRef} style={{ width: "100%", paddingTop: 32 }}>
          {live_in && live_in !== "other" && <DwellingSize />}
        </div>
        <div ref={moveDetailRef} style={{ width: "100%", paddingTop: 16 }}>
          <Fade show={!!move_size}>
            {live_in !== "other" && <MoveDetails />}
          </Fade>
        </div>
      </Row>
    </Container>
  );
};

export default YourMove;
